import { useMsal } from '@azure/msal-react'
import { removeAuthInterceptor, setupAuthInterceptor } from '@src/services/auth-interceptor'
import { type ReactNode, useEffect, useRef } from 'react'

interface Props {
  children: ReactNode
}

const AuthInterceptorProvider = ({ children }: Props) => {
  const { instance } = useMsal()
  const interceptorRef = useRef<number | null>(null)

  useEffect(() => {
    if (interceptorRef.current === null) {
      interceptorRef.current = setupAuthInterceptor(instance)
    }

    return () => {
      if (interceptorRef.current !== null) {
        removeAuthInterceptor(interceptorRef.current)
        interceptorRef.current = null
      }
    }
  }, [instance])

  return children
}

export default AuthInterceptorProvider
